// extracted by mini-css-extract-plugin
export default {"iconWrapper":"MoreActionsButton_iconWrapper__59fqM","dropdown":"MoreActionsButton_dropdown__dKiXM","arrow":"MoreActionsButton_arrow__9ydnx","icon":"MoreActionsButton_icon__btkEc"};